import store from '@state/store'
import { lazyLoadView } from '@router/helpers'
import { authMethods } from '@state/helpers'

export default [
  {
    methods: {
      ...authMethods,
    },
    path: '/company/:companyId/store',
    name: 'companyStore',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "profile" */ './views/marketplace.vue')
      ),
    meta: {
      authRequired: true,
      // HACK: In order to share data between the `beforeResolve` hook
      // and the `props` function, we must create an object for temporary
      // data only used during route resolution.
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.companyId = parseInt(routeTo.params.companyId)
        handleRoute()
        function handleRoute() {
          let storeOrdersAction = 'marketplace/fetchMyOrders'
          if (
            store.getters['auth/canManageCompanies']() ||
            store.getters['auth/canEditCompany'](routeTo.params.companyId)
          ) {
            storeOrdersAction = 'marketplace/fetchOrders'
          }

          return Promise.all([
            store.dispatch('marketplace/fetchProducts', {
              companyId: routeTo.params.companyId,
            }),
            store.dispatch(storeOrdersAction, {
              companyId: routeTo.params.companyId,
            }),
            store.dispatch('marketplace/fetchGroupsHierarchy', {
              companyId: routeTo.params.companyId,
            }),
          ])
            .then(() => {
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'Products' } })
            })
        }
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({
      companyId: route.meta.tmp.companyId,
    }),
  },
]
